import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import CityPage from "@/pages/CityPage";
import ProjectPage from "@/pages/ProjectPage";
import Demo from "@/pages/Demo";
import Developers from "@/pages/Developers";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function SmoothScroll() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let id;
        const raf = (t) => {
            lenis.raf(t);
            id = requestAnimationFrame(raf);
        };
        id = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(id);
            lenis.destroy();
        };
    }, []);
    return null;
}

function NotFound() {
    return (
        <div className="mx-auto max-w-7xl px-5 pb-24 pt-44 text-center sm:px-8" data-testid="not-found-page">
            <p className="eyebrow">404</p>
            <h1 className="mt-4 font-serif text-5xl text-ivory">This Sthaan doesn't exist.</h1>
            <p className="mx-auto mt-4 max-w-md text-sm text-mist">
                The page you're looking for has moved or never was.
            </p>
            <Link
                to="/"
                data-testid="not-found-home-link"
                className="mt-8 inline-block rounded-full bg-gold px-7 py-3 text-sm font-semibold text-obsidian transition-colors hover:bg-gold-bright"
            >
                Back to Sthaan
            </Link>
        </div>
    );
}

function App() {
    return (
        <div className="App noise min-h-screen bg-obsidian text-ivory">
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/discover" element={<Discover category="all" />} />
                        <Route path="/residential" element={<Discover category="residential" />} />
                        <Route path="/commercial" element={<Discover category="commercial" />} />
                        <Route path="/city/:slug" element={<CityPage />} />
                        <Route path="/project/:slug" element={<ProjectPage />} />
                        <Route path="/demo" element={<Demo />} />
                        <Route path="/developers" element={<Developers />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/terms" element={<Legal kind="terms" />} />
                        <Route path="/privacy" element={<Legal kind="privacy" />} />
                        <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
